import { ISelectItem } from '../Select';

export const sortSelectItems: ISelectItem[] = [
	{
		id: 0,
		value: 'content',
		title: 'По содержанию',
	},
	{
		id: 1,
		value: 'date asc',
		title: 'По дате (возрастание)',
	},
	{
		id: 2,
		value: 'date desc',
		title: 'По дате (убывание)',
	},
	{
		id: 3,
		value: 'amount asc',
		title: 'По сумме (возрастание)',
	},
	{
		id: 4,
		value: 'amount desc',
		title: 'По сумме (убывание)',
	},
];
